import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LoginScreen.css';
import logo from './img/logo.png';

const API_BASE_URL = '/api'; // URL relativa para funcionar em qualquer IP

const LoginScreen = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Verificar se já está autenticado ao carregar o componente
  useEffect(() => {
    const token = localStorage.getItem('painelAuthToken');
    if (token) {
      // Verificar se o token ainda é válido
      checkToken(token);
    }
  }, []);

  const checkToken = async (token) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/verify`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.data.success) {
        onLogin({
          token: token,
          user: response.data.data.user
        });
      } else {
        localStorage.removeItem('painelAuthToken');
      }
    } catch (error) {
      localStorage.removeItem('painelAuthToken');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        username,
        password
      });

      if (response.data.success) {
        onLogin(response.data.data);
      } else {
        setError(response.data.error || 'Erro no login');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError('Erro de conexão. Verifique se o servidor está rodando.');
      }
    }

    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-overlay"></div>
      </div>
      
      <div className="login-content">
        <div className="login-box">
          <div className="login-header">
            <div className="login-logo">
              <img src={logo} alt="Logo" className="login-logo-icon" />
              <h1>Painel de Chamadas</h1>
            </div>
            <p>Faça login para acessar o sistema</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Usuário</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Digite seu usuário"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Senha</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Digite sua senha"
                required
                disabled={loading}
              />
            </div>

            {error && (
              <div className="error-message">
                <span>⚠️</span>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="login-button"
              disabled={loading || !username || !password}
            >
              {loading ? (
                <>
                  <div className="login-spinner"></div>
                  Entrando...
                </>
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Sistema de Painel de Chamadas</p>
            <small>Versão 1.0</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;